{
  "name": "typenvx",
  "version": "0.1.12",
  "description": "Typenv is a modern, type-safe alternative to .env files, providing advanced validation, intelligent interpolation, and conditional logic for better environment management.",
  "bin": {
    "typenv": "./dist/cli/index.js"
  },
  "main": "./dist/src/index.js",
  "module": "./dist/src/index.mjs",
  "types": "./dist/src/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "example_test": "ts-node ./examples/index",
    "build": "tsup",
    "test": "jest",
    "test:watch": "jest --watch"
  },
  "keywords": [
    "typenv",
    "envx",
    "tenv",
    "env",
    "dotenv",
    "env-loader",
    "config",
    "config-loader",
    "env-validation",
    "type-safe-config",
    "env-types",
    "environment-variables",
    "typed-env",
    "env-generator"
  ],
  "author": "trymagic",
  "license": "MIT",
  "devDependencies": {
    "@types/jest": "^29.5.14",
    "@types/lodash.debounce": "^4.0.9",
    "@types/node": "^22.15.29",
    "jest": "^29.7.0",
    "ts-jest": "^29.3.4",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3"
  },
  "dependencies": {
    "chokidar": "^4.0.3",
    "colorette": "^2.0.20",
    "commander": "^14.0.0",
    "lodash.debounce": "^4.0.8"
  }
}
